module.exports = __webpack_public_path__ + "static/media/maf-37.b4754572.png";